module.exports = __webpack_public_path__ + "img/product2p.ec4fa682.png";